if ("NodeList" in window && !NodeList.prototype.forEach) {
	console.info("polyfill for IE11");
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

(function () {
	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll("p") || [];
	paragraph.forEach(
		(e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
	);


	if (document.querySelector("#booking-form #CheckOut")) {
		let dateTodayCheckOut = new Date();
        

		let tomorrowCheckOut = new Date(dateTodayCheckOut);
		tomorrowCheckOut.setDate(dateTodayCheckOut.getDate() + 1);
		
		let year = tomorrowCheckOut.getFullYear();
		let month = String(tomorrowCheckOut.getMonth() + 1).padStart(2, '0'); 
		let day = String(tomorrowCheckOut.getDate()).padStart(2, '0');
		let formattedDateCheckOut = year + '-' + month + '-' + day;
		
	
		let dateInputCheckOut = document.querySelector("#booking-form #CheckOut");
		dateInputCheckOut.value = formattedDateCheckOut;
	}


})();

if (document.getElementById("fsCountdown")) {
	const fsCountdown = new Date(document.getElementById('fsCountdown').getAttribute('data-time'));

	// Countdown
	let fsDays = 0;
	let fsHours = 0;
	let fsMinutes = 0;
	let fsSeconds = 0;

	// Initialize and update the countdown
	tick();

	// Set up the interval to update the countdown every second
	let fsTimer = setInterval(tick.bind(this), 1000);

	function updateRemaining(fsDistance) {
			fsDays = Math.floor(fsDistance / (1000 * 60 * 60 * 24));
			fsHours = Math.floor((fsDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			fsMinutes = Math.floor((fsDistance % (1000 * 60 * 60)) / (1000 * 60)) - 1;
			fsSeconds = Math.floor((fsDistance % (1000 * 60)) / 1000);

			document.getElementById('fsDays').innerHTML = fsDays;
			document.getElementById('fsHours').innerHTML = fsHours;
			document.getElementById('fsMinutes').innerHTML = fsMinutes;
			document.getElementById('fsSeconds').innerHTML = fsSeconds;
	}

	function tick() {
			const currentTime = new Date();
			console.log( {currentTime} );
			let fsDistance = Math.max(fsCountdown - currentTime, 0);

			console.log( fsDistance );

			// Update the countdown
			updateRemaining(fsDistance);

			// Check if the countdown has reached zero
			if (fsDistance <= 1000) { // Less than or equal to 1 second
					clearInterval(fsTimer);
					fsDistance = 0; // Set fsDistance to 0 to ensure accurate display
			}
	}
}


